import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/ad/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/ad/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/ad/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/ad/delete/${id}`)
}
